import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import history from 'routing/history';
import Button, { BackButton } from 'components/Button';
import Alert from 'components/Alert';
import useNextAndPrevUrl from '../../hooks/useNextAndPrevUrl';
import ViewAnimator from '../../components/ViewAnimator';
import { sendIDVerificationResult, addValidStep, setIdVerified } from '../../state';
import { STEP_PATHS } from '../../consts';
import { NavigationButtons } from '../../styled';
import { StepHeading } from '../../components/StepHeading/styled';

const IDVerification = () => {
  const dispatch = useDispatch();
  const { claimType, step } = useParams();
  const { nextUrl, prevUrl } = useNextAndPrevUrl(claimType, step);
  const { idVerified, claimID } = useSelector((state) => state.nomadInsurance.claims);
  const [error, setError] = useState(false);

  const onIdVerified = (experienceID) => {
    dispatch(sendIDVerificationResult(experienceID, claimID));
    dispatch(setIdVerified(true));
    dispatch(addValidStep(STEP_PATHS.ID_VERIFICATION));
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    function handleResponse(e) {
      if (e.status === 200) {
        onIdVerified(e.experienceTransactionId);
      } else {
        setError(true);
      }
    }

    // eslint-disable-next-line no-new
    new window.TruliooClient({
      publicKey: process.env.REACT_APP_TRULIOO_PUBLIC_KEY,
      accessTokenURL: `${process.env.REACT_APP_BACKEND_API_URL}/verifications`,
      handleResponse
    });
  }, []);

  const onNext = () => history.push(nextUrl);

  const onBack = () => history.push(prevUrl);

  return (
    <ViewAnimator>
      <StepHeading>ID Verification</StepHeading>

      {!error && !idVerified && <div id="trulioo-embedid" />}

      {error && (
        <Alert variant="danger" label="Something went wrong">
          Something went wrong with verifying your documents. Please refresh the page to
          try again, and if the problem persists, contact customer service.
        </Alert>
      )}

      {idVerified && <div>Your ID has been successfully verified!</div>}

      {(idVerified || error) && (
        <NavigationButtons>
          <BackButton onClick={onBack} variant="dark">
            Back
          </BackButton>
          <Button onClick={onNext} disabled={!idVerified}>
            Next
          </Button>
        </NavigationButtons>
      )}
    </ViewAnimator>
  );
};

export default IDVerification;
